import * as Scrivito from "scrivito"

export const BenefitsWidget = Scrivito.provideWidgetClass("BenefitsWidget", {
  attributes: {
    title: ["widgetlist", { only: "TextWidget", maximum: 1 }],
    subtitle: ["widgetlist", { only: "TextWidget", maximum: 1 }],
    columnHeaders: ["widgetlist", { only: ["TextWidget"] }],
    items: ["widgetlist", { only: ["BenefitItemWidget"] }]
  }
})
